<template>
  <b-row no-gutters class="h-100 template-one">
    <b-col cols="12" sm="6" xl="8"
      class="p-5 d-none d-sm-flex justify-content-center align-items-center background-container"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"></b-col>
    <b-col cols="12" sm="6" xl="4"
      class="bg-light p-5 d-flex flex-column justify-content-center align-items-center shadow-lg">
      <div class="justify-content-end">
        <button class="btn btn-primary-outline mt-0 mr-0" disabled>Anmelden</button>
      </div>
      <div class="text-center my-auto">
        <img :src="logo" alt="logo" class="img-fluid mx-auto mb-4" />
        <div class="title mb-3">{{ title }}</div>
        <div class="disclaimer font-weight-light">
          <vue-typed-js class="d-block" :loop="true" :strings="disclaimer">
            <span class="typing"></span>
          </vue-typed-js>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "TemplateOne",
  data() {
    return {
      logo: require("@/assets/logo.png"),
      backgroundImage: require("@/assets/bg.jpg"),
      title: process.env.VUE_APP_TITLE,
      disclaimer: [
        process.env.VUE_APP_DISCLAIMER_FIRST_LINE,
        process.env.VUE_APP_DISCLAIMER_SECOND_LINE,
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.template-one {
  .title {
    font-size: 3rem;
  }

  .disclaimer {
    font-size: 1.5rem;
  }

  .background-container {
    background-position: center center;
    background-size: cover;
    box-shadow: inset 0rem 0rem 5rem rgba(0, 0, 0, 0.2) !important;
  }
}
</style>
